import cx from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './DotActive.css';
import { TFeature } from '../../../../../../common/types/map';
import { IApplicationState } from '../../../../../../common/types/redux';
import { selectActiveFeature } from '../../../../../selectors';
import { useMapContext } from '../../../context';

interface IDotActiveProps {
  resultsAvailable: boolean;
  detailsVisible: boolean;
}

interface IIconLayout {
  isSmall: boolean;
}

export const DotActive: React.FC<IDotActiveProps> = ({
  resultsAvailable: isResultsAvailable,
  detailsVisible: isDetailsVisible,
}) => {
  const { ymaps, map } = useMapContext();
  const selectedFeature = useSelector<IApplicationState, TFeature | null>(selectActiveFeature);

  const iconLayout = React.useRef(({ isSmall }: IIconLayout) =>
    ymaps.templateLayoutFactory.createClass(
      `<div class="${cx(
        styles['dailyrent-container'],
        isSmall && styles['container--small'],
        styles['container--blue'],
      )}">{% if properties.count > 1 %}{% if properties.count <= 9 %}{{properties.count}}{% else %}9+{% endif %}{% endif %}</div>`,
    ),
  );
  const placemarkObject = React.useRef<YMaps.GeoObject | null>(null);

  React.useEffect(() => {
    if (placemarkObject.current) {
      map.geoObjects.remove(placemarkObject.current);
      placemarkObject.current = null;
    }

    if (!isResultsAvailable || (isDetailsVisible && !selectedFeature)) {
      return;
    }

    if (selectedFeature) {
      const isSmallPlacemark = selectedFeature.properties.offers.length === 1;

      placemarkObject.current = new ymaps.GeoObject(
        {
          ...selectedFeature,
          type: 'Feature',
          id: 'DotActiveFeature',
        },
        {
          iconLayout: iconLayout.current({
            isSmall: isSmallPlacemark,
          }),
        },
      );

      map.geoObjects.add(placemarkObject.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFeature]);

  React.useEffect(() => {
    if (!isResultsAvailable || isDetailsVisible) {
      if (placemarkObject.current) {
        map.geoObjects.remove(placemarkObject.current);
        placemarkObject.current = null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResultsAvailable, isDetailsVisible]);

  return null;
};
